export enum TpcsRole {
  Admin = 'tpcs:admin',
}

export const enum Permissions {
  tpcsUser = 'tpcs:user',
  listUsers = 'tpcs:list:members',
  assignAdminPermission = 'tpcs:truepill:assign:admin',
}
